import { FC } from "react";
import BottomSheet from "./BottomSheet";
import PriceLines from "./PriceLines";

/**
 * "Price details", slid up from the total bar on every step (1NOW-11155).
 * The lines are PriceLines, which the desktop's overview card draws too.
 */
const PriceDetailsSheet: FC<{
  open: boolean;
  onClose: () => void;
  invoice: any;
  carName?: string;
}> = ({ open, onClose, invoice, carName }) => (
  <BottomSheet open={open} onClose={onClose} title="Price details">
    <PriceLines invoice={invoice} carName={carName} />
  </BottomSheet>
);

export default PriceDetailsSheet;
